/**
 * Fixed bottom action bar for full-bleed dashboard flows (new email / SMS / push, etc.).
 * Pairs with Tailwind `w-screenWithoutSideMenu` and `left-[21rem]` (16rem sidebar + layout chrome).
 */
export const dashboardBottomActionBarClassName =
  'flex items-center justify-center fixed bottom-0 z-50 bg-white/95 backdrop-blur-md overflow-hidden w-screenWithoutSideMenu left-[21rem] h-24 border-t border-custom-lightSilver shadow-[0_-4px_24px_rgba(0,0,0,0.05)]';
